/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetMetaDataDto,
    PersonalAssetMetaDataDtoFromJSON,
    PersonalAssetMetaDataDtoFromJSONTyped,
    PersonalAssetMetaDataDtoToJSON,
} from './PersonalAssetMetaDataDto';
import {
    PersonalAssetSpecialTypeEnum,
    PersonalAssetSpecialTypeEnumFromJSON,
    PersonalAssetSpecialTypeEnumFromJSONTyped,
    PersonalAssetSpecialTypeEnumToJSON,
} from './PersonalAssetSpecialTypeEnum';
import {
    PersonalAssetTypeEnum,
    PersonalAssetTypeEnumFromJSON,
    PersonalAssetTypeEnumFromJSONTyped,
    PersonalAssetTypeEnumToJSON,
} from './PersonalAssetTypeEnum';

/**
 * 
 * @export
 * @interface PersonalAssetWithValueDto
 */
export interface PersonalAssetWithValueDto {
    /**
     * 
     * @type {PersonalAssetTypeEnum}
     * @memberof PersonalAssetWithValueDto
     */
    type: PersonalAssetTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetSpecialTypeEnum}
     * @memberof PersonalAssetWithValueDto
     */
    sourceType: PersonalAssetSpecialTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetMetaDataDto}
     * @memberof PersonalAssetWithValueDto
     */
    metaData?: PersonalAssetMetaDataDto;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetWithValueDto
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetWithValueDto
     */
    interest?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetWithValueDto
     */
    fee?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetWithValueDto
     */
    reward?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    iconName: PersonalAssetWithValueDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    colorName: PersonalAssetWithValueDtoColorNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    currencyCode: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetWithValueDto
     */
    lastUpdated: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetWithValueDto
     */
    createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalAssetWithValueDto
     */
    deleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetWithValueDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetWithValueDto
     */
    portfolioId: string;
}

/**
* @export
* @enum {string}
*/
export enum PersonalAssetWithValueDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum PersonalAssetWithValueDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function PersonalAssetWithValueDtoFromJSON(json: any): PersonalAssetWithValueDto {
    return PersonalAssetWithValueDtoFromJSONTyped(json, false);
}

export function PersonalAssetWithValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetWithValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PersonalAssetTypeEnumFromJSON(json['type']),
        'sourceType': PersonalAssetSpecialTypeEnumFromJSON(json['sourceType']),
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetMetaDataDtoFromJSON(json['metaData']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'interest': !exists(json, 'interest') ? undefined : json['interest'],
        'fee': !exists(json, 'fee') ? undefined : json['fee'],
        'reward': !exists(json, 'reward') ? undefined : json['reward'],
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'id': json['id'],
        'name': json['name'],
        'currencyCode': json['currencyCode'],
        'lastUpdated': (new Date(json['lastUpdated'])),
        'createdAt': (new Date(json['createdAt'])),
        'deleted': json['deleted'],
        'order': json['order'],
        'portfolioId': json['portfolioId'],
    };
}

export function PersonalAssetWithValueDtoToJSON(value?: PersonalAssetWithValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PersonalAssetTypeEnumToJSON(value.type),
        'sourceType': PersonalAssetSpecialTypeEnumToJSON(value.sourceType),
        'metaData': PersonalAssetMetaDataDtoToJSON(value.metaData),
        'value': value.value,
        'interest': value.interest,
        'fee': value.fee,
        'reward': value.reward,
        'iconName': value.iconName,
        'colorName': value.colorName,
        'id': value.id,
        'name': value.name,
        'currencyCode': value.currencyCode,
        'lastUpdated': (value.lastUpdated.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'deleted': value.deleted,
        'order': value.order,
        'portfolioId': value.portfolioId,
    };
}

